import {
  ANICO_EMBED_TOKEN,
  ANICO_TEST_EMBED_TOKEN,
  PACLIFE_EMBED_TOKEN,
  PACLIFE_TEST_EMBED_TOKEN,
  PROTECTIVE_EMBED_TOKEN,
  PROTECTIVE_TEST_EMBED_TOKEN,
  SBLI_EMBED_TOKEN,
  SBLI_TEST_EMBED_TOKEN
} from 'config/App';
import { Colors, FontSizes, FontWeights } from 'constants/Clementine';
import { cleanQuote, getRedirectUrl } from 'utils/FormIntegrations';
import styled from 'styled-components';
import { Button as HexureButton, Tabs, Link, Tag, Copy } from '@hexure/ui';
import { Icon } from '@mdi/react';
import {
  mdiCheckboxBlankCircleOutline,
  mdiCheckboxOutline,
  mdiCheckboxBlankOutline,
  mdiCheckboxMarkedCircle,
  mdiChevronRight,
  mdiChevronDown,
  mdiChevronUp,
  mdiCheckboxMarkedCircleOutline
} from '@mdi/js';

import AlqApi from 'utils/AlqApi';
import AmbestInfo from 'shared/AmbestInfo';
import ApplicintModal from 'alq/ApplicintModal';
import Button from 'shared/Button';
// import { CUSTOM_ACTIONS } from 'constants/App';
import FirelightEappModal from 'alq/FirelightEappModal';
import FirelightEticketModal from 'alq/FirelightEticketModal';
import LifedxEticketModal from 'alq/LifedxEticketModal';
import Loader from 'shared/Loader';
import Modal from 'shared/Modal';
import Moment from 'moment';
import NmbTermEticketModal from 'alq/nmb_term_eticket/Index';
import NmbWholeLifeEticketModal from 'alq/nmb_wl_eticket/Index';
import Numeral from 'numeral';
import OpenUrlModal from 'alq/OpenUrlModal';
import PostToUrlModal from 'alq/PostToUrlModal';
import { ProductContext } from 'alq/Context';
import PropTypes from 'prop-types';
import PsgEappModal from 'alq/PsgEappModal';
import QuoteActionModal from 'alq/QuoteActionModal';
import QuoteForms from 'alq/QuoteForms';
import QuotePremiums from 'alq/QuotePremiums';
import React from 'react';
import RequestFormsModal from 'alq/RequestFormsModal';
import ShareQuotesModal from 'alq/ShareQuotesModal';
import ZeroState from 'shared/ZeroState';
import FirelightSimplifiedEticketModal from './FirelightSimplifiedEticketModal';

// Styled Components - Matching Annuity QuoteCard Design
const Wrapper = styled.div`
  display: flex;
  align-items: center;
`;

const Checkbox = styled.div`
  display: flex;
  padding: 16px 20px 0px 0px;
  align-items: flex-start;
  align-self: stretch;
  cursor: pointer;
`;

const Content = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  flex: 1;
  border-radius: 8px;
  border-width: ${props => (props.$isSelected ? '2px' : '1px')};
  border-style: solid;
  border-color: ${props => (props.$isSelected ? props.$color : '#E5E5E5')};
  background: #fff;
`;

const Top = styled.div`
  display: flex;
  flex: 1;
  padding: 16px;
  align-items: center;
  gap: 16px;
  justify-content: space-between;
  background: ${props => `${props.$color}0d`};
`;

const TopLeft = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
`;

const Logo = styled.img`
  height: 30px;
  width: auto;
`;

const ProductName = styled.h5`
  color: #000;
  font-family: Roboto;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 16px;
  margin: 0;
  padding: 0;
`;

const Bottom = styled.div`
  display: flex;
  padding: 16px;
  justify-content: space-between;
`;

const BottomLeft = styled.div`
  align-self: stretch;
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: space-between;
`;

const Meta = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 6px;
  flex-wrap: wrap;
  flex: 1;
`;

const TagLabel = styled.span`
  font-style: italic;
  margin-right: 4px;
`;

const TagValue = styled.span`
  font-weight: 600;
`;

const BottomRight = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
`;

const PremiumValue = styled.div`
  color: #000;
  text-align: right;
  font-family: Roboto;
  font-size: 24px;
  font-style: normal;
  font-weight: 500;
  line-height: 24px;
  align-self: stretch;
  border-bottom: 1px solid #e5e5e5;
  padding: 0px 0px 12px 0px;
`;

const Premiums = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  flex-direction: column;
  padding-top: 12px;
`;

const Premium = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 4px 0px;
  align-items: center;
  gap: 12px;
`;

const PremiumLabel = styled.span`
  color: #999;
  font-family: Roboto;
  font-size: 13px;
  font-style: italic;
  font-weight: 400;
  line-height: 14px;
`;

const PremiumAmount = styled.span`
  color: #000;
  font-family: Roboto;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 14px;
`;

const Details = styled.div`
  background: #fff;
  border-radius: 8px;
`;

const TabContent = styled.div`
  padding: 30px;
  max-width: 100%;
  overflow-x: auto;
`;

const Features = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

const Feature = styled.div`
  display: flex;
  gap: 10px;
  align-items: center;
`;

const ApproximateLabel = styled.span`
  color: #999;
  font-family: Roboto;
  font-size: 13px;
  font-style: italic;
  font-weight: 400;
  line-height: 14px;
`;

class QuoteCard extends React.Component {
  static propTypes = {
    customAction: PropTypes.string,
    hasActions: PropTypes.bool,
    isUniversalQuoter: PropTypes.bool,
    onOpenFirelightModal: PropTypes.func,
    onSelect: PropTypes.func,
    showActionsBtnText: PropTypes.string,
    onShowActions: PropTypes.func,
    onStartEApp: PropTypes.func,
    productFeatures: PropTypes.array,
    quote: PropTypes.object,
    selected: PropTypes.bool,
    solveFor: PropTypes.string,
    premiumMode: PropTypes.string,
    showDetails: PropTypes.bool,
    isStartEAppBtnEnabled: PropTypes.bool
  };

  static defaultProps = {
    showActionsBtnText: 'Start eApp',
    onShowActions: () => {}
  };

  constructor(props) {
    super(props);

    // Check if this is an IUL quote to set default active tab
    const isIUL = props.quote?.product_type === 'IUL' || props.quote?.product_type_name === 'IUL' || (props.quote?.product_name && props.quote.product_name.includes('IUL'));
    this.state = {
      product: null,
      ambest_record: null,
      forms: null,
      form_tags: null,
      show_details: this.props.showDetails !== undefined ? this.props.showDetails : this.props.isUniversalQuoter ? true : false,
      user_toggled_details: false, // Track if user has manually toggled details
      active_details: isIUL ? 'expenses' : 'features', // IUL defaults to 'expenses', others to 'features'
      loading: false,
      hovering: false,
      modal: null,
      action: null,
      standard_packet_error: false,

      // IUL-specific data
      iul_expenses: null,
      iul_investments: null,
      iul_riders: null,

      anico_eticket_guid: null,
      firelight_eticket: null,
      firelight_eapp: null,
      psg_eapp: null,
      paclife_eticket_guid: null,
      protective_eticket_guid: null,
      nmb_eticket_guid: null,
      sbli_eticket_guid: null
    };
  }

  componentDidMount() {
    this._loadProduct();
  }

  componentDidUpdate(prevProps) {
    // If parent explicitly changes showDetails prop, reset user toggle flag and sync state
    if (this.props.showDetails !== undefined && prevProps.showDetails !== this.props.showDetails) {
      this.setState({
        show_details: this.props.showDetails,
        user_toggled_details: false // Reset user toggle when parent changes the prop
      });
    }
  }

  _setEticket = (name, value) => {
    this.setState({
      [name]: value
    });
  };

  _setFirelightEticket = firelight_eticket => {
    this.setState({ firelight_eticket });
  };

  _setFirelightEapp = firelight_eapp => {
    this.setState({ firelight_eapp });
  };

  _setPsgEapp = psg_eapp => {
    this.setState({ psg_e_app });
  };

  _toggleDetails = () => {
    this.setState({
      show_details: !this.state.show_details,
      user_toggled_details: true // Mark that user has manually toggled
    });
  };

  _toggleContent = (active_details, loadContent) => {
    this.setState({ active_details });

    if (loadContent) {
      loadContent();
    }
  };

  _toggleHover = hovering => {
    this.setState({ hovering });
  };

  _toggleModal = modal => {
    this.setState({ modal });
  };

  _loadProduct = () => {
    if (!this.state.product) {
      this.setState({
        loading: true
      });

      AlqApi.loadProduct(this.props.quote.product_id).then(response => {
        this.setState({
          product: response.data,
          loading: false
        });
      });
    }
  };

  _loadAmbestRecord = () => {
    if (!this.state.ambest_record) {
      this.setState({
        loading: true
      });

      AlqApi.loadAmbestRecord(this.props.quote.carrier_id).then(response => {
        this.setState({
          ambest_record: response.data[0],
          loading: false
        });
      });
    }
  };

  _loadForms = () => {
    if (!this.state.forms) {
      this.setState({
        loading: true
      });

      const params = {
        carrier_id: this.props.quote.carrier_id,
        product_group_id: this.props.quote.product_group_id,
        state: this.props.quote.state
      };

      if (this.context.alq.is_beta) {
        params.beta = true;
      }

      AlqApi.loadQuoteForms(params).then(response => {
        AlqApi.loadFormTags().then(form_tags => {
          this.setState({
            form_tags,
            forms: response.data,
            loading: false
          });
        });
      });
    }
  };

  // IUL-specific load functions
  _loadIulExpenses = () => {
    if (!this.state.iul_expenses && this.props.quote.product_id) {
      this.setState({
        loading: true
      });

      AlqApi.loadIulPolicyFees(this.props.quote.product_id).then(expenses => {
        this.setState({
          iul_expenses: expenses,
          loading: false
        });
      });
    }
  };

  _loadIulInvestments = () => {
    if (!this.state.iul_investments && this.props.quote.product_id) {
      this.setState({
        loading: true
      });

      AlqApi.loadIulInvestments(this.props.quote.product_id).then(investments => {
        this.setState({
          iul_investments: investments,
          loading: false
        });
      });
    }
  };

  _loadIulRiders = () => {
    if (!this.state.iul_riders && this.props.quote.product_id) {
      this.setState({
        loading: true
      });

      AlqApi.loadIulRiders(this.props.quote.product_id).then(riders => {
        this.setState({
          iul_riders: riders,
          loading: false
        });
      });
    }
  };

  _handleDownloadStandardPacket = () => {
    this.setState({
      modal: 'standard_packet'
    });

    AlqApi.downloadStandardPacket({
      carrier_id: this.props.quote.carrier_id,
      product_group_id: this.props.quote.product_group_id,
      state: this.props.quote.state
    })
      .then(response => {
        this.setState({
          modal: null
        });

        window.open(response.data.url);
      })
      .catch(() => {
        this.setState({
          standard_packet_error: true
        });
      });
  };

  _handleQuoteAction = action => {
    const actions = {
      anico: 'anico',
      request_forms: 'request_forms',
      webhook_post: 'post_to_url',
      simple_url: 'open_url',
      default: 'open_url',
      typeform: 'open_url',
      formassembly: 'open_url',
      '123_contact_form': 'open_url',
      cognito_form: 'open_url',
      formsite: 'open_url',
      jotform: 'open_url',
      formstack: 'open_url',
      wufoo: 'open_url',
      google_form: 'open_url',
      applicant: 'applicint',
      nmb_term_eticket: 'nmb_term_eticket',
      nmb_whole_life_eticket: 'nmb_whole_life_eticket',
      paclife: 'paclife',
      protective: 'protective',
      firelight: 'firelight',
      simplified_eticket: 'simplified_eticket',
      psg_eapp: 'psg_eapp',
      download_quotes_pdf: 'share',
      sbli: 'sbli',
      send_quote_as_email: 'share',
      send_quote_as_text: 'share',
      standard_packet: 'standard_packet'
    };

    if (action.action_type === 'standard_packet') {
      this._handleDownloadStandardPacket();
    }
    if (action.action_data.activity === 'simplified_eticket') {
      this.setState({
        action,
        modal: 'simplified_eticket'
      });
    } else {
      this.setState({
        action,
        modal: actions[action.action_type]
      });
    }
  };
  render() {
    const {
      action,
      active_details,
      ambest_record,
      anico_eticket_guid,
      firelight_eticket,
      firelight_eapp,
      form_tags,
      forms,
      iul_expenses,
      iul_investments,
      iul_riders,
      loading,
      modal,
      nmb_eticket_guid,
      paclife_eticket_guid,
      product,
      protective_eticket_guid,
      psg_eapp,
      sbli_eticket_guid,
      show_details,
      standard_packet_error
    } = this.state;

    // If user has manually toggled, always use local state
    // Otherwise, use prop if provided, or local state as fallback
    const shouldShowDetails = this.state.user_toggled_details ? show_details : this.props.showDetails !== undefined ? this.props.showDetails : show_details;

    const { alq, client, agent, ran_quote_data } = this.context;
    const type = action?.action_type?.includes('download') ? 'download' : action?.action_type?.includes('email') ? 'email' : action?.action_type?.includes('text') ? 'text' : 'text';
    const quote_params = this.context.quoter_config.quote_params || [];
    const { customAction, onSelect, productFeatures, quote, selected } = this.props;

    const eticketCheck = this.context?.alq?.custom_actions.some(action => /e[-]?ticket/i.test(action.label) && action.carrier_ids?.includes(quote.carrier_id));

    const styles = this.styles();
    const base_lifedx_form_data = [
      { name: 'agency_name', value: alq.agency_name },
      { name: 'pi_first_name', value: client.first_name },
      { name: 'pi_last_name', value: client.last_name },
      { name: 'pi_date_of_birth', value: ran_quote_data.date_of_birth ? Moment(ran_quote_data.date_of_birth).format('YYYY-MM-DD') : null },
      { name: 'producer_first_name', value: agent.first_name },
      { name: 'producer_last_name', value: agent.last_name },
      { name: 'producer_email', value: agent.email },
      { name: 'producer_phone', value: agent.phone },
      // Protective fields
      { name: 'first_name', value: client.first_name },
      { name: 'last_name', value: client.last_name },
      { name: 'agent_first_name', value: agent.first_name },
      { name: 'agent_last_name', value: agent.last_name },
      { name: 'agent_phone', value: agent.phone },
      { name: 'agent_email', value: agent.email },
      ...quote_params
    ];
    const details = [
      {
        id: 'features',
        label: 'Features',
        loadContent: this._loadProduct,
        content:
          product && product.product_feature_ids && product.product_feature_ids.length ? (
            product.product_feature_ids.map(feature_id => {
              const feature = productFeatures.find(pf => pf.id === feature_id);

              return (
                <div key={feature.id} style={styles.feature}>
                  <i className='mdi mdi-check' style={styles.feature_icon} /> {feature.name}
                </div>
              );
            })
          ) : (
            <ZeroState icon='mdi-playlist-check' message="This product doesn't have any features" />
          )
      },
      {
        id: 'carrier',
        label: 'Carrier Overview',
        loadContent: this._loadAmbestRecord,
        content: <AmbestInfo details={ambest_record} />
      },
      {
        id: 'premiums',
        label: 'Premiums',
        content: <QuotePremiums premiumMode={this.props.premiumMode} quote={quote} solveFor={this.props.solveFor} />
      }
    ];

    // Check if this is an IUL quote
    const isIUL = quote.product_type === 'IUL' || quote.product_type_name === 'IUL' || (quote.product_name && quote.product_name.includes('IUL')); // For IUL quotes, restructure tabs: Expenses (Default), Forms, Carrier, Riders, Investments
    if (isIUL) {
      const iulDetails = [
        {
          id: 'expenses',
          label: 'Expenses',
          loadContent: this._loadIulExpenses,
          content:
            iul_expenses && iul_expenses.length > 0 ? (
              <div style={{ width: '100%' }}>
                <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                  <thead>
                    <tr style={{ borderBottom: '2px solid #e5e5e5' }}>
                      <th style={{ padding: '12px', textAlign: 'left', fontWeight: '600' }}>Type</th>
                      <th style={{ padding: '12px', textAlign: 'left', fontWeight: '600' }}>Amount</th>
                      <th style={{ padding: '12px', textAlign: 'left', fontWeight: '600' }}>Duration</th>
                      <th style={{ padding: '12px', textAlign: 'left', fontWeight: '600' }}>Mode</th>
                    </tr>
                  </thead>
                  <tbody>
                    {iul_expenses.map((expense, index) => (
                      <tr key={index} style={{ borderBottom: '1px solid #f5f5f5' }}>
                        <td style={{ padding: '12px' }}>{expense.type || expense.fee_type || '-'}</td>
                        <td style={{ padding: '12px' }}>{expense.amount || expense.fee_amount || '-'}</td>
                        <td style={{ padding: '12px' }}>{expense.duration || expense.fee_duration || '-'}</td>
                        <td style={{ padding: '12px' }}>{expense.mode || expense.fee_mode || '-'}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            ) : (
              <ZeroState icon='mdi-currency-usd' message='No expense information available' />
            )
        }
      ];

      // Add Forms tab if allowed
      if (alq.allow_forms || this.props.isUniversalQuoter) {
        iulDetails.push({
          id: 'forms',
          label: 'Forms',
          loadContent: this._loadForms,
          content: <QuoteForms forms={forms} formTags={form_tags} quote={quote} />
        });
      }

      // Add Carrier tab
      iulDetails.push({
        id: 'carrier',
        label: 'Carrier',
        loadContent: this._loadAmbestRecord,
        content: <AmbestInfo details={ambest_record} />
      });

      // Add Riders tab
      iulDetails.push({
        id: 'riders',
        label: 'Riders',
        loadContent: this._loadIulRiders,
        content:
          iul_riders && iul_riders.length > 0 ? (
            <div style={{ width: '100%' }}>
              <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                <thead>
                  <tr style={{ borderBottom: '2px solid #e5e5e5' }}>
                    <th style={{ padding: '12px', textAlign: 'left', fontWeight: '600' }}>Type</th>
                    <th style={{ padding: '12px', textAlign: 'left', fontWeight: '600' }}>Name</th>
                    <th style={{ padding: '12px', textAlign: 'left', fontWeight: '600' }}>Description</th>
                  </tr>
                </thead>
                <tbody>
                  {iul_riders.map((rider, index) => (
                    <tr key={index} style={{ borderBottom: '1px solid #f5f5f5' }}>
                      <td style={{ padding: '12px' }}>{rider.type || rider.rider_type || '-'}</td>
                      <td style={{ padding: '12px' }}>{rider.name || rider.rider_name || '-'}</td>
                      <td style={{ padding: '12px' }}>{rider.description || rider.rider_description || '-'}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          ) : (
            <ZeroState icon='mdi-shield-plus' message='No riders available' />
          )
      });

      // Add Investments tab
      iulDetails.push({
        id: 'investments',
        label: 'Investments',
        loadContent: this._loadIulInvestments,
        content:
          iul_investments && iul_investments.length > 0 ? (
            <div style={{ width: '100%' }}>
              <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                <thead>
                  <tr style={{ borderBottom: '2px solid #e5e5e5' }}>
                    <th style={{ padding: '12px', textAlign: 'left', fontWeight: '600' }}>Fund Name</th>
                    <th style={{ padding: '12px', textAlign: 'left', fontWeight: '600' }}>Crediting Strategy</th>
                    <th style={{ padding: '12px', textAlign: 'left', fontWeight: '600' }}>Crediting Frequency</th>
                    <th style={{ padding: '12px', textAlign: 'left', fontWeight: '600' }}>Rate</th>
                    <th style={{ padding: '12px', textAlign: 'left', fontWeight: '600' }}>Index</th>
                  </tr>
                </thead>
                <tbody>
                  {iul_investments.map((investment, index) => (
                    <tr key={index} style={{ borderBottom: '1px solid #f5f5f5' }}>
                      <td style={{ padding: '12px' }}>{investment.fund_name || investment.investment_name || '-'}</td>
                      <td style={{ padding: '12px' }}>{investment.crediting_strategy || investment.strategy || '-'}</td>
                      <td style={{ padding: '12px' }}>{investment.crediting_frequency || investment.frequency || '-'}</td>
                      <td style={{ padding: '12px' }}>{investment.rate ? `${investment.rate}%` : investment.crediting_rate ? `${investment.crediting_rate}%` : '-'}</td>
                      <td style={{ padding: '12px' }}>{investment.index || investment.index_name || '-'}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          ) : (
            <ZeroState icon='mdi-chart-line' message='No investment information available' />
          )
      });

      // Override default details with IUL-specific structure
      details.length = 0;
      details.push(...iulDetails);
    } else {
      // Non-IUL products: keep existing structure but adjust for forms
      if (alq.allow_forms || this.props.isUniversalQuoter) {
        details.splice(1, 0, {
          id: 'forms',
          label: 'Forms',
          loadContent: this._loadForms,
          content: <QuoteForms forms={forms} formTags={form_tags} quote={quote} />
        });
      }
    }

    const share_actions = {
      download_quotes_pdf: 'download',
      send_quote_as_email: 'email',
      send_quote_as_text: 'text'
    };

    if (quote.agent_message && quote.agent_message.length) {
      details.push({
        id: 'agent_message',
        label: 'Important Information',
        content: <div style={{ lineHeight: '1.8em' }}>{quote.agent_message}</div>
      });
    }

    return (
      <div className={this.props.className} style={styles.container}>
        {modal === 'quote_actions' ? (
          <QuoteActionModal onAction={this._handleQuoteAction} onClose={this._toggleModal.bind(null, null)} onOpenFirelightModal={this.props.onOpenFirelightModal} quote={quote} />
        ) : null}

        {modal === 'request_forms' ? <RequestFormsModal onBackClick={this._toggleModal.bind(null, 'quote_actions')} onClose={this._toggleModal.bind(null, null)} quote={quote} /> : null}

        {modal === 'post_to_url' ? <PostToUrlModal action={action} onClose={this._toggleModal.bind(null, null)} params={cleanQuote(quote, ran_quote_data, quote_params, agent, client)} /> : null}

        {modal === 'open_url' ? (
          <OpenUrlModal
            inline={action.open_in_modal}
            onClose={this._toggleModal.bind(null, null)}
            url={
              action.action_type === 'simple_url'
                ? action.url
                : getRedirectUrl({
                    action,
                    quote,
                    quote_params,
                    agent,
                    client,
                    selected_config: ran_quote_data
                  })
            }
          />
        ) : null}

        {modal === 'anico' ? (
          <LifedxEticketModal
            eticketGuid={anico_eticket_guid}
            formData={base_lifedx_form_data.concat([{ name: 'is_test', value: alq.use_anico_test_servers }])}
            key={anico_eticket_guid}
            onClose={this._toggleModal.bind(null, null)}
            onCreate={this._setEticket.bind(null, 'anico_eticket_guid')}
            provider='anico'
            quote={quote}
            title={action.label}
            token={alq.use_anico_test_servers ? ANICO_TEST_EMBED_TOKEN : ANICO_EMBED_TOKEN}
          />
        ) : null}

        {modal === 'applicint' ? <ApplicintModal onBackClick={this._toggleModal.bind(null, 'quote_actions')} onClose={this._toggleModal.bind(null, null)} quote={quote} /> : null}

        {modal === 'nmb_term_eticket' ? (
          <NmbTermEticketModal eticketGuid={nmb_eticket_guid} onClose={this._toggleModal.bind(null, null)} onCreate={this._setEticket.bind(null, 'nmb_eticket_guid')} quote={quote} />
        ) : null}

        {modal === 'nmb_whole_life_eticket' ? (
          <NmbWholeLifeEticketModal eticketGuid={nmb_eticket_guid} onClose={this._toggleModal.bind(null, null)} onCreate={this._setEticket.bind(null, 'nmb_eticket_guid')} quote={quote} />
        ) : null}

        {modal === 'paclife' ? (
          <LifedxEticketModal
            eticketGuid={paclife_eticket_guid}
            formData={base_lifedx_form_data.concat([{ name: 'is_test', value: alq.use_paclife_test_servers }])}
            key={paclife_eticket_guid}
            onClose={this._toggleModal.bind(null, null)}
            onCreate={this._setEticket.bind(null, 'paclife_eticket_guid')}
            provider='paclife'
            quote={quote}
            title={action.label}
            token={alq.use_paclife_test_servers ? PACLIFE_TEST_EMBED_TOKEN : PACLIFE_EMBED_TOKEN}
          />
        ) : null}

        {modal === 'protective' ? (
          <LifedxEticketModal
            eticketGuid={protective_eticket_guid}
            formData={base_lifedx_form_data.concat([
              { name: 'is_test', value: alq.use_protective_test_servers },
              { name: 'agency_code', value: alq.protective_agency_code },
              { name: 'agency_contract_number', value: alq.protective_contract_number }
            ])}
            key={protective_eticket_guid}
            onClose={this._toggleModal.bind(null, null)}
            onCreate={this._setEticket.bind(null, 'protective_eticket_guid')}
            provider='protective_life'
            quote={quote}
            title={action.label}
            token={alq.use_protective_test_servers ? PROTECTIVE_TEST_EMBED_TOKEN : PROTECTIVE_EMBED_TOKEN}
          />
        ) : null}

        {modal === 'firelight' && action.action_data.activity === 'e_ticket' ? (
          <FirelightEticketModal action={action} eticket={firelight_eticket} onClose={this._toggleModal.bind(null, null)} onSave={this._setFirelightEticket} quote={quote} />
        ) : null}

        {modal === 'firelight' && action.action_data.activity === 'e_app' ? (
          <FirelightEappModal action={action} eapp={firelight_eapp} onClose={this._toggleModal.bind(null, null)} onSave={this._setFirelightEapp} quote={quote} />
        ) : null}

        {modal === 'simplified_eticket' && action.action_data.activity === 'simplified_eticket' ? (
          <FirelightSimplifiedEticketModal
            action={action}
            onClose={this._toggleModal.bind(null, null)}
            onSave={this._setFirelightSimplifiedEticket}
            quote={quote}
            agent={agent}
            client={client}
            ran_quote_data={ran_quote_data}
          />
        ) : null}

        {modal === 'psg_eapp' ? <PsgEappModal eapp={psg_eapp} onClose={this._toggleModal.bind(null, null)} onCreate={this._setPsgEapp} quote={quote} /> : null}

        {modal === 'sbli' ? (
          <LifedxEticketModal
            eticketGuid={sbli_eticket_guid}
            formData={base_lifedx_form_data.concat([
              { name: 'is_test', value: alq.use_sbli_test_servers },
              { name: 'agency_code', value: alq.sbli_agency_code }
            ])}
            key={sbli_eticket_guid}
            onClose={this._toggleModal.bind(null, null)}
            onCreate={this._setEticket.bind(null, 'sbli_eticket_guid')}
            provider='sbli'
            quote={quote}
            title={action.label}
            token={alq.use_sbli_test_servers ? SBLI_TEST_EMBED_TOKEN : SBLI_EMBED_TOKEN}
          />
        ) : null}

        {modal === 'share' ? (
          <ShareQuotesModal
            action={share_actions[action.action_type]}
            onBackClick={this._toggleModal.bind(null, 'quote_actions')}
            onClose={this._toggleModal.bind(null, null)}
            selectedQuotes={[quote.guid]}
          />
        ) : null}

        {modal === 'standard_packet' ? (
          <Modal
            buttons={
              standard_packet_error
                ? [
                    {
                      color: '#e5e5e5',
                      fontColor: '#999',
                      children: 'Back',
                      onClick: this._toggleModal.bind(null, 'quote_actions'),
                      style: { margin: '0 10px 0 auto' }
                    },
                    {
                      children: 'Done',
                      onClick: this._toggleModal.bind(null, null)
                    }
                  ]
                : null
            }
            maxWidth={800}
            onClose={this._toggleModal.bind(null, null)}
            title='Standard Packet'
          >
            <div style={styles.modal_content}>{standard_packet_error ? <span>No Standard Packet forms were found for this carrier.</span> : <Loader />}</div>
          </Modal>
        ) : null}

        {/* Conditional rendering based on quoter type */}
        {this.props.isUniversalQuoter ? (
          // NEW LAYOUT FOR UNIVERSAL QUOTER
          <Wrapper style={{ marginBottom: 15 }}>
            {/* Show checkbox only in individual life quoter (not universal quoter) */}
            {!this.props.isUniversalQuoter && this.props.hasActions !== false && (
              <Checkbox onClick={onSelect.bind(null, quote)}>
                <Icon color={selected ? this.context.color : '#999'} path={selected ? mdiCheckboxOutline : mdiCheckboxBlankOutline} size='28px' />
              </Checkbox>
            )}

            <Content $color={this.context.color} $isSelected={selected}>
              <Top $color={this.context.color}>
                <TopLeft>
                  <Logo src={quote.carrier_logo_url} />
                  <ProductName>{this.props.isUniversalQuoter ? quote.carrier_name || quote.product_name : quote.product_name}</ProductName>
                </TopLeft>
                {/* Show action button in Universal Quoter */}
                {this.props.isUniversalQuoter && this.props.onShowActions && (
                  <HexureButton icon={mdiChevronRight} onClick={this.props.onShowActions} small={true} disabled={!this.props.isStartEAppBtnEnabled}>
                    {this.props.showActionsBtnText || 'Start eApp'}
                  </HexureButton>
                )}
              </Top>

              <Bottom>
                <BottomLeft>
                  <Meta>
                    {/* Health Category Tag */}
                    {quote.carrier_health_category && (
                      <Tag color='SUBTLE_GRAY'>
                        <TagLabel>Health Class</TagLabel>
                        <TagValue>
                          {quote.carrier_health_category} {quote.table_rate_letter ? `(Table ${quote.table_rate_letter})` : ''}
                        </TagValue>
                      </Tag>
                    )}
                    {/* Face Amount Tag (for non-IUL) */}
                    {!isIUL && quote.face_amount && (
                      <Tag color='SUBTLE_GRAY'>
                        <TagLabel>Face Amount</TagLabel>
                        <TagValue>{Numeral(quote.face_amount).format('$0,0')}</TagValue>
                      </Tag>
                    )}
                    {/* For IUL show Modal Premium and DB Type */}
                    {isIUL && quote.modal_premium && (
                      <Tag color='SUBTLE_GRAY'>
                        <TagLabel>Modal Premium</TagLabel>
                        <TagValue>{Numeral(quote.modal_premium).format('$0,0')}</TagValue>
                      </Tag>
                    )}
                    {isIUL && quote.death_benefit_type && (
                      <Tag color='SUBTLE_GRAY'>
                        <TagLabel>DB Type</TagLabel>
                        <TagValue>{quote.death_benefit_type}</TagValue>
                      </Tag>
                    )}
                  </Meta>
                  <Link onClick={this._toggleDetails} style={{ display: 'flex', alignItems: 'center', marginTop: '8px' }}>
                    {shouldShowDetails ? (
                      <>
                        Hide Details <Icon color={this.context.color} path={mdiChevronUp} size='18px' />
                      </>
                    ) : (
                      <>
                        Show Details <Icon color={this.context.color} path={mdiChevronDown} size='18px' />
                      </>
                    )}
                  </Link>
                </BottomLeft>

                <BottomRight>
                  {/* For IUL, show specific IUL metrics */}
                  {isIUL ? (
                    <>
                      <PremiumValue>{quote.accumulation ? Numeral(quote.accumulation).format('$0,0') : 'N/A'}</PremiumValue>
                      <Premiums>
                        <Premium>
                          <PremiumLabel>Face Amount</PremiumLabel>
                          <PremiumAmount>{quote.face_amount ? Numeral(quote.face_amount).format('$0,0') : 'N/A'}</PremiumAmount>
                        </Premium>
                        <Premium>
                          <PremiumLabel>Death Benefit</PremiumLabel>
                          <PremiumAmount>{quote.death_benefit ? Numeral(quote.death_benefit).format('$0,0') : 'N/A'}</PremiumAmount>
                        </Premium>
                      </Premiums>
                    </>
                  ) : (
                    <>
                      {/* Show primary premium (annual as default or first available) */}
                      <PremiumValue>
                        {quote.premium_annual ? Numeral(quote.premium_annual).format('$0,0.00') : quote.premium_monthly ? Numeral(quote.premium_monthly).format('$0,0.00') : 'N/A'}
                        <br />
                        <ApproximateLabel>{quote.premium_annual ? 'Annual Premium' : quote.premium_monthly ? 'Monthly Premium' : 'Premium'}</ApproximateLabel>
                      </PremiumValue>
                      {/* Show other premium modes */}
                      <Premiums>
                        {[
                          { value: 'monthly', label: 'Monthly' },
                          { value: 'quarterly', label: 'Quarterly' },
                          { value: 'semi_annual', label: 'Semi-Annually' }
                        ]
                          .filter(mode => quote[`premium_${mode.value}`])
                          .map(mode => (
                            <Premium key={mode.value}>
                              <PremiumLabel>{mode.label}</PremiumLabel>
                              <PremiumAmount>{Numeral(quote[`premium_${mode.value}`]).format('$0,0.00')}</PremiumAmount>
                            </Premium>
                          ))}
                      </Premiums>
                    </>
                  )}
                </BottomRight>
              </Bottom>

              {/* Details section with tabs */}
              {shouldShowDetails && (
                <Details>
                  <Tabs
                    style={{ borderTop: '1px solid #e5e5e5' }}
                    tabs={details.map(item => ({
                      isActive: item.id === active_details,
                      label: item.label,
                      onClick: this._toggleContent.bind(null, item.id, item.loadContent)
                    }))}
                  />
                  <TabContent>
                    {loading ? (
                      <Loader />
                    ) : active_details === 'features' && product && product.product_feature_ids && product.product_feature_ids.length ? (
                      <Features>
                        {product.product_feature_ids.map(feature_id => {
                          const feature = productFeatures.find(pf => pf.id === feature_id);
                          return (
                            <Feature key={feature.id}>
                              <Icon color={Colors.GREEN.hex} path={mdiCheckboxMarkedCircleOutline} size='20px' />
                              <Copy>{feature.name}</Copy>
                            </Feature>
                          );
                        })}
                      </Features>
                    ) : (
                      details.find(item => item.id === active_details)?.content
                    )}
                  </TabContent>
                </Details>
              )}
            </Content>
          </Wrapper>
        ) : (
          // OLD LAYOUT FOR INDIVIDUAL LIFE QUOTER
          <div style={{ display: 'flex', marginBottom: 15 }}>
            {/* Show checkbox only in individual life quoter */}
            {this.props.hasActions !== false && (
              <div onClick={onSelect.bind(null, quote)} style={styles.checkbox_wrapper}>
                <div style={Object.assign({}, styles.checkbox, selected && styles.checkbox_marked)}>{selected ? <i className='mdi mdi-check-bold' style={styles.checkbox_icon} /> : null}</div>
              </div>
            )}

            {/* Show Start eApp button when hasActions is false */}
            {this.props.hasActions === false && this.props.onStartEApp && (
              <div style={styles.start_eapp_wrapper}>
                <Button onClick={() => this.props.onStartEApp(quote)} style={styles.start_eapp_button}>
                  Start eApp
                </Button>
              </div>
            )}

            <div style={styles.card}>
              {customAction || eticketCheck ? <i className='mdi mdi-text-box' style={styles.action_icon} title='E-ticket enabled' /> : null}
              <div onMouseEnter={this._toggleHover.bind(null, true)} onMouseLeave={this._toggleHover.bind(null, false)} style={styles.face}>
                <div style={Object.assign({}, styles.logo, { backgroundImage: `url(${quote.carrier_logo_url})` })} />
                <div style={styles.title}>
                  <div style={styles.product_name}>{quote.product_name}</div>
                  <div style={styles.health_category}>
                    {quote.carrier_health_category} {quote.table_rate_letter ? `(Table ${quote.table_rate_letter})` : null}
                  </div>
                  {isIUL ? (
                    <div style={styles.face_amount}>
                      <div>{quote.modal_premium ? `Modal Premium: ${Numeral(quote.modal_premium).format('$0,0')}` : ''}</div>
                      <div>{quote.death_benefit_type ? `DB Type: ${quote.death_benefit_type}` : ''}</div>
                    </div>
                  ) : (
                    <div style={styles.face_amount}>{Numeral(quote.face_amount).format('$0,0')}</div>
                  )}
                </div>
                {isIUL ? (
                  <div style={styles.premium}>
                    <div>
                      <strong>Accumulation:</strong>
                      <span style={styles.premium_amount}>{quote.accumulation ? Numeral(quote.accumulation).format('$0,0') : 'N/A'}</span>
                    </div>
                    <div>
                      <strong>Face Amount:</strong>
                      <span style={styles.premium_amount}>{quote.face_amount ? Numeral(quote.face_amount).format('$0,0') : 'N/A'}</span>
                    </div>
                    <div>
                      <strong>Death Benefit:</strong>
                      <span style={styles.premium_amount}>{quote.death_benefit ? Numeral(quote.death_benefit).format('$0,0') : 'N/A'}</span>
                    </div>
                    <div>
                      <strong>Premium Load:</strong>
                      <span style={styles.premium_amount}>{quote.premium_load ? `${quote.premium_load}%` : 'N/A'}</span>
                    </div>
                    <div>
                      <strong>Current Rate:</strong>
                      <span style={styles.premium_amount}>{quote.current_rate ? `${quote.current_rate}%` : 'N/A'}</span>
                    </div>
                  </div>
                ) : (
                  <div style={styles.premium}>
                    {[
                      { value: 'monthly', label: 'Monthly' },
                      { value: 'quarterly', label: 'Quarterly' },
                      { value: 'semi_annual', label: 'Semi-Annually' },
                      { value: 'annual', label: 'Annually' }
                    ].map(payment_mode => (
                      <div key={payment_mode.value}>
                        {payment_mode.label}:
                        <span style={styles.premium_amount}>{quote[`premium_${payment_mode.value}`] ? Numeral(quote[`premium_${payment_mode.value}`]).format('$0,00.00') : 'N/A'}</span>
                      </div>
                    ))}
                  </div>
                )}
                <div style={styles.hover}>
                  <Button onClick={this._toggleModal.bind(null, 'quote_actions')}>Get Started</Button>
                </div>
              </div>
              {shouldShowDetails ? (
                <div style={styles.details}>
                  <div style={styles.menu}>
                    {details.map(item => (
                      <div
                        key={item.id}
                        onClick={this._toggleContent.bind(null, item.id, item.loadContent)}
                        style={Object.assign({}, styles.menu_item, item.id === active_details && styles.menu_item_active)}
                      >
                        {item.label}
                      </div>
                    ))}
                  </div>
                  <div style={styles.details_content}>{loading ? <Loader /> : details.find(item => item.id === active_details).content}</div>
                </div>
              ) : null}
              <div className='ixn-quote-card--show-details' onClick={this._toggleDetails} style={styles.expand_pane}>
                {shouldShowDetails ? 'Hide Details' : 'Show Details'}
                <i className={shouldShowDetails ? 'mdi mdi-chevron-up' : 'mdi mdi-chevron-down'} style={{ fontSize: 18, marginBottom: 2 }} />
              </div>
            </div>
          </div>
        )}
      </div>
    );
  }

  styles = () => {
    return {
      container: {
        marginBottom: 15
      },
      checkbox_wrapper: {
        padding: '65px 20px 20px 0px',
        cursor: 'pointer'
      },
      checkbox: {
        border: `2px solid ${Colors.GRAY.hex}`,
        borderRadius: 3,
        width: 22,
        height: 22,
        lineHeight: '20px',
        textAlign: 'center'
      },
      checkbox_marked: {
        background: Colors.GREEN.hex,
        border: `1px solid ${Colors.GREEN.hex}`,
        color: '#fff'
      },
      checkbox_icon: {
        fontSize: 16
      },
      start_eapp_wrapper: {
        padding: '65px 20px 20px 0px',
        display: 'flex',
        alignItems: 'flex-start'
      },
      start_eapp_button: {
        fontSize: '12px',
        padding: '8px 16px',
        minHeight: 'auto'
      },
      universal_start_eapp_button: {
        fontSize: '14px',
        padding: '12px 24px',
        minHeight: 'auto',
        backgroundColor: '#007bff',
        color: '#fff',
        border: 'none',
        borderRadius: '6px',
        fontWeight: '600',
        cursor: 'pointer',
        transition: 'all 0.2s ease',
        boxShadow: '0 3px 6px rgba(0, 123, 255, 0.3)',
        letterSpacing: '0.5px'
      },
      card: {
        border: this.props.selected ? `1px solid ${Colors.GREEN.hex}` : '1px solid #e5e5e5',
        boxShadow: this.props.selected ? `0px 0px 0px 1px ${Colors.GREEN.hex}` : 'none',
        borderRadius: 4,
        background: '#fff',
        overflow: 'hidden',
        width: '100%'
      },
      face: {
        padding: '20px 15px',
        display: 'flex',
        alignItems: 'center',
        position: 'relative',
        overflow: 'hidden'
      },
      hover: {
        position: 'absolute',
        top: 0,
        bottom: 0,
        right: 0,
        width: 220,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: '#fff',
        transform: this.state.hovering ? 'translateX(0%)' : 'translateX(100%)',
        transition: 'all .2s'
      },
      logo: {
        height: 60,
        width: 150,
        flexShrink: 0,
        backgroundSize: 'contain',
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'center',
        marginRight: 40,
        marginLeft: 20
      },
      title: {
        marginRight: 20
      },
      product_name: {
        fontSize: FontSizes.LARGE,
        fontWeight: FontWeights.MEDIUM,
        marginBottom: 4
      },
      health_category: {
        fontSize: 13,
        color: '#777',
        margin: '6px 0 8px',
        fontStyle: 'italic'
      },
      face_amount: {
        fontSize: FontSizes.LARGE,
        fontWeight: FontWeights.MEDIUM
      },
      premium: {
        textAlign: 'right',
        marginLeft: 'auto',
        flexShrink: 0,
        color: '#777',
        fontSize: FontSizes.MEDIUM,
        lineHeight: '2em'
      },
      premium_amount: {
        fontWeight: FontWeights.BOLD,
        color: Colors.GRAY.hex,
        marginLeft: 6,
        fontSize: FontSizes.LARGE
      },
      details: {
        position: 'relative'
      },
      expand_pane: {
        background: '#f5f5f5',
        borderTop: '1px solid #e5e5e5',
        borderRadius: '0 0 4px 4px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        height: 26,
        fontSize: 10,
        textTransform: 'uppercase',
        color: '#999',
        fontWeight: FontWeights.MEDIUM,
        letterSpacing: 1,
        cursor: 'pointer'
      },
      action_icon: {
        background: this.context.color,
        borderBottomRightRadius: 10,
        borderTopLeftRadius: 3,
        color: 'fff',
        fontSize: 20,
        padding: 5,
        position: 'absolute'
      },
      menu: {
        display: 'flex',
        alignItems: 'bottom',
        borderBottom: '1px solid #e5e5e5'
      },
      menu_item: {
        fontWeight: FontWeights.MEDIUM,
        padding: '10px 20px',
        cursor: 'pointer'
      },
      menu_item_active: {
        color: this.context.color,
        boxShadow: `inset 0px -2px 0px 0px ${this.context.color}`
      },
      details_content: {
        padding: 20,
        minHeight: 200,
        overflow: 'auto'
      },
      feature: {
        lineHeight: '30px',
        display: 'flex',
        alignItems: 'center'
      },
      feature_icon: {
        fontSize: 18,
        color: Colors.GREEN.hex,
        marginRight: 10
      },
      modal_content: {
        minWidth: 400,
        padding: 40,
        fontSize: FontSizes.MEDIUM,
        lineHeight: '1.5em',
        position: 'relative',
        textAlign: 'center',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
      }
    };
  };
}

QuoteCard.contextType = ProductContext;

export default QuoteCard;
